var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionRedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1.785 1h24v24h-24z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.785 1)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#f85359",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.387 4.27a9.95 9.95 0 0 1 7.32-3.198c5.514 0 9.984 4.475 9.984 9.994 0 .586-.05 1.16-.147 1.718m-8.798 8.224a10.09 10.09 0 0 1-1.64.035C4.872 20.732.724 16.385.724 11.066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.708 3.392v7.468l-2.877 2.88"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m2.47 1.33-.095 3.952M6.356 5.354l-3.862-.067"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 17.624a5.625 5.625 0 1 1-11.25.002 5.625 5.625 0 0 1 11.25-.002z",
    stroke: "#f85359",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f85359"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.55 20.031a.834.834 0 0 1-.262.617.847.847 0 0 1-.614.255.856.856 0 0 1-.613-.255.843.843 0 0 1-.26-.617c0-.238.086-.446.26-.62a.847.847 0 0 1 1.227 0 .839.839 0 0 1 .262.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.675 14.025a.75.75 0 0 1 .745.663l.005.087v2.866a.75.75 0 0 1-1.495.088l-.005-.088v-2.866a.75.75 0 0 1 .75-.75z",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionRedIcon);
export default __webpack_public_path__ + "static/media/action-red-icon.7e6d7e64fc71ce0568a03929864f2b74.svg";
export { ForwardRef as ReactComponent };